import AllocatorInfoDetails from './AllocatorInfoDetails'

export default AllocatorInfoDetails
